import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'src.pages.UnibanPopUp.title',
    defaultMessage: 'Let the windshield experts take it from here',
  },
  text: {
    id: 'src.pages.UnibanPopUp.text',
    defaultMessage: 'Contact our partner Uniban for any windshield or glass damage to your vehicle. Call ',
  },
  text2: {
    id: 'src.pages.UnibanPopUp.text2',
    defaultMessage: ' and follow the prompts to select the option to report a windshield claim.',
  },
  text3: {
    id: 'src.pages.UnibanPopUp.text3',
    defaultMessage: 'Make sure to screenshot or write down the phone number before exiting this page. Also, be sure to have your policy number: {policyNumber} ready before calling',
  },
  text4: {
    id: 'src.pages.UnibanPopUp.text4',
    defaultMessage: 'Heads up! ',
  },
  text5: {
    id: 'src.pages.UnibanPopUp.text5',
    defaultMessage: 'Getting your windshield fixed won’t impact your insurance premium. There’s no need to open a claim on our end and we’ll delete this draft for you.',
  },
  btn: {
    id: 'src.pages.UnibanPopUp.btn',
    defaultMessage: 'Back to dashboard',
  },
});
